const classPrefix = 'result-banner'
const dataPrefix = 'data-result-banner'
const $container = document.querySelector(`[${dataPrefix}]`)

if ($container) {
    resultBanner({$container})
}

export function resultBanner({$container}) {

}




